import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { DropDown } from '../fields';

import '../../styles/cards/promo.css';

class PromoCard extends React.Component {
  rewardLabel() {
    const { promo } = this.props;
    const reward = promo.reward || {};

    switch (reward.type) {
      case 'PERCENT':
        return `${reward.percent || 0}% off`;
      case 'FIXED':
        return `£${Number(reward.fixed_amount || 0).toFixed(2)} off`;
      case 'FREE_ITEM':
        return `Free item${reward.max_qty ? ` × ${reward.max_qty}` : ''}`;
      case 'BUY_X_GET_Y':
        return `Buy ${reward.buy_qty || 0}, get ${reward.get_qty || 0}`;
      default:
        return reward.type || '-';
    }
  }

  render() {
    const { t, promo, actions, data, onChange } = this.props;

    return (
      <div className='promo-card'>
        <div className='promo-card-status'>
          <span
            className={
              promo.is_active
                ? 'promo-status promo-status-active'
                : 'promo-status promo-status-inactive'
            }
          >
            {promo.is_active ? t('ACTIVE') : t('INACTIVE')}
          </span>
        </div>

        <div className='promo-card-body'>
          <p className='promo-card-body-title'>{promo.name}</p>

          {promo.description && (
            <p className='promo-card-body-description'>
              {promo.description}
            </p>
          )}

          <div className='promo-card-grid'>
            <p>
              <span>{t('Reward')}</span>
              {this.rewardLabel()}
            </p>

            <p>
              <span>{t('Activation')}</span>
              {promo.activation_type === 'CODE'
                ? `${t('Code')}: ${promo.code || '-'}`
                : t('Automatic')}
            </p>

            <p>
              <span>{t('Start')}</span>
              {moment(promo.start_date).format('DD MMM YYYY HH:mm')}
            </p>

            <p>
              <span>{t('End')}</span>
              {moment(promo.end_date).format('DD MMM YYYY HH:mm')}
            </p>

            <p>
              <span>{t('Priority')}</span>
              #{promo.priority || 100}
            </p>

            <p>
              <span>{t('Trigger')}</span>
              {(promo.trigger && promo.trigger.type) || 'NONE'}
            </p>
          </div>
        </div>

        <div className='promo-card-right'>
          <DropDown
            bull={true}
            isTable={true}
            actions={actions}
            data={data}
            onChange={onChange}
          />
        </div>
      </div>
    );
  }
}

PromoCard.propTypes = {
  promo: PropTypes.any,
  actions: PropTypes.array,
  data: PropTypes.any,
  onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
};

PromoCard.defaultProps = {
  actions: [],
  onChange: Function.prototype,
};

export default withTranslation()(PromoCard);
